module.exports = __webpack_public_path__ + "static/portfolio_gallery_24-0519049daff83ae9aac73f83591c92e3.jpg";